const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getCommentsApi = async (leadId, role, page = 1, perPage = 15) => {
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('[getCommentsApi] Ошибка: Токен авторизации не найден.');

        // throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/${role}/lead/leads/${leadId}/comments?page=${page}&per_page=${perPage}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();
        return {
            data: result.data || [],
            meta: {
                total_count: result.meta?.total || 0,
                current_page: result.meta?.current_page || page,
                per_page: result.meta?.per_page || perPage,
                total_pages: result.meta?.last_page || 1
            }
        };
    } catch (error) {
        console.error('[getCommentsApi] Ошибка сети или другая ошибка при получении комментариев:', error);
        throw error;
    }
};